<template>
  <div>
    <el-dialog :visible.sync="visible" width="560px" :center="false">
      <div slot="title" class="title-container"><span>Edit contact infos of this sheet</span></div>
      <el-form label-width="120px">
        <el-form-item label="Address">
          <el-input v-model="tAddress" placeholder="Enter the order adress" size="mini" style="width: 360px"></el-input>
        </el-form-item>
        <el-form-item label="Phone">
          <el-input v-model="tPhone" placeholder="Enter the phone" size="mini" style="width: 360px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible">Cancel</el-button>
        <el-button size="mini" type="primary" @click="handleSubmit">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderAddressModify } from '../api'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogAddress',
  computed: {
    visible: {
      get () {
        return this.dialogVisible
      },
      set (val) {
        this.$emit('closed')
      }
    },
    ...mapState('edit', ['id', 'type', 'address', 'phone'])
  },
  data () {
    return {
      tAddress: '',
      tPhone: ''
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions({
      reload: 'edit/loadOrder'
    }),
    async handleSubmit () {
      await orderAddressModify(this.id, {
        phone: this.tPhone,
        address: this.tAddress
      })

      this.$message({
        message: 'Operation successful',
        type: 'success'
      })
      this.reload(this.id)
      this.$emit('closed')
    },
    dialogFormVisible () {
      this.tAddress = this.address
      this.tPhone = this.phone
      this.$emit('closed')
    }
  },
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.tAddress = this.address
        this.tPhone = this.phone
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  color: #000;
  line-height: 48px;
  padding: 0 60px 0 20px;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
</style>
